export enum BankPledgeOptions {
    UNKNOWN = 0,
    IN_PLEDGE = 1,
    NOT_IN_PLEDGE = 2,
}
